import { render } from "./share-planner-settings-link.vue?vue&type=template&id=2e915976&scoped=true&ts=true"
import script from "./share-planner-settings-link.vue?vue&type=script&lang=ts"
export * from "./share-planner-settings-link.vue?vue&type=script&lang=ts"

import "./share-planner-settings-link.vue?vue&type=style&index=0&id=2e915976&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e915976"]])

export default __exports__